var _path, _path2, _path3, _path4, _rect, _rect2, _circle, _path5, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 250 L120 120 L200 220 L280 100 L350 250",
    fill: "none",
    stroke: "#2D5A27",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 250 L150 150 L220 230",
    fill: "none",
    stroke: "#4A7C44",
    strokeWidth: 6,
    strokeLinejoin: "round",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 310 Q200 270 350 310",
    fill: "none",
    stroke: "#00A8E8",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 330 Q200 290 340 330",
    fill: "none",
    stroke: "#00A8E8",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 210,
    width: 100,
    height: 60,
    rx: 15,
    fill: "white",
    stroke: "#333",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 220,
    width: 30,
    height: 25,
    rx: 5,
    fill: "#E0E0E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 270,
    r: 8,
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 260 L130 270",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 370,
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 24,
    textAnchor: "middle",
    fill: "#333"
  }, "\r\n    LECHCAMPING\r\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 395,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    textAnchor: "middle",
    fill: "#2D5A27",
    letterSpacing: 2
  }, "\r\n    SPIRKENHOF\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c72928667bb578bd4f882a498164a2b4.svg";
export { ForwardRef as ReactComponent };